import { useTranslation } from 'react-i18next'

const ParentsDivorcingStart = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="parents-dicorcing-start-title"
      {...props}
    >
      <title id="parents-dicorcing-start-title">{t('antagonists:parentsdivorcing:components:start')}</title>
      <defs>
        <clipPath id="mum-b">
          <path
            d="M1546.71 188.83c-32.51 0-53.14 25.09-53.91 54.22-.74 27.66 4.56 38.78 7.44 49.41 4.65 17.17-4.77 34.3-3.81 34.3s22.48-11.26 24.49-16.02c2.39-5.67-1.03-24.42-1.03-24.42l48.31 3.63s-6.81 12.1-.13 22.13 22.77 11.1 22.77 11.1-7.29-17.9-3.95-29.24 10.39-25.14 10.39-49.11-20.96-56.01-50.55-56.01Z"
            style={{
              fill: '#feca1b',
            }}
          />
        </clipPath>
        <clipPath id="mum-c">
          <path
            d="M1535.51 314.92c4.49 3.12 15.88 2 19.04 0 7.45-4.74 19.01-17.06 21.96-21.78 3.93-6.29 8.73-36.69-1.3-44.89-16.68-13.63-10.83-31.16-22.18-30.82-6.49.19-12.45 15.84-22.02 24.14-7.16 6.2-19.92 10.44-21.52 16.22-2.38 8.6-1.85 28.61 4.88 37.83 7.96 10.89 13.7 14.14 21.14 19.31Z"
            style={{
              fill: '#d4a55e',
            }}
          />
        </clipPath>
        <style>
          {
            '.d{fill:#006443}.e{fill:#ee7f00}.f{fill:#feca1b}.g{fill:#00a183}.h{fill:#d4a55e}.i{fill:#a93985}.j{fill:#4a4630}.k{fill:#497125}.l{fill:#49465a}.m{clip-path:url(#mum-c)}.n{clip-path:url(#mum-b)}'
          }
        </style>
      </defs>
      <path
        d="M1546.71 188.83c-32.51 0-53.14 25.09-53.91 54.22-.74 27.66 4.56 38.78 7.44 49.41 4.65 17.17-4.77 34.3-3.81 34.3s22.48-11.26 24.49-16.02c2.39-5.67-1.03-24.42-1.03-24.42l48.31 3.63s-6.81 12.1-.13 22.13 22.77 11.1 22.77 11.1-7.29-17.9-3.95-29.24 10.39-25.14 10.39-49.11-20.96-56.01-50.55-56.01Z"
        style={{
          fill: '#feca1b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-b)',
        }}
      >
        <path
          d="M1551.63 189.21s1.85 16.5 1.85 23.05c0 6.55-.62 11.92-.62 11.92l1.74.26s1.13-2.62.82-12.7c-.31-10.08-1.54-21.87-1.54-21.87l-2.26-.65Z"
          style={{
            fill: '#d4a55e',
          }}
        />
      </g>
      <path
        d="M1479.43 900.76s1.94 33.23-.44 47.27c-2.38 14.04-6.45 25.14-6.45 25.14l31.61 5.64 8.5-23.3s-3.77-17.74-4.78-24.45c-1.01-6.72-2-28.66-2-28.66l-26.44-1.63Z"
        style={{
          fill: '#006443',
        }}
      />
      <path
        d="M1486.03 957.52c-10.82-.53-13.18 9.32-16.79 16.62-3.61 7.29-10.77 15.75-11.64 21.1-.87 5.35-2.53 11.52.11 12.29s19.29 2.77 24.78 2.52c5.49-.25 19.19-1.31 20.35-5.26 1.16-3.95 1.67-15.71 1.67-15.71l4.18 1.19 7.73-5.66s1.89-17.51.43-24.28-6.04-17.78-7.46-17.27c-1.43.51.04 16.6-2.07 20.9-2.11 4.29-4.89 8.5-4.89 8.5s-6.89-14.48-16.39-14.94Z"
        style={{
          fill: '#49465a',
        }}
      />
      <path
        d="M1607.11 900.53s-2.42 33.2-.24 47.27c2.17 14.07 6.08 25.23 6.08 25.23l-31.68 5.18-8.16-23.42s4.03-17.68 5.13-24.38c1.1-6.7 2.41-28.63 2.41-28.63l26.46-1.25Z"
        style={{
          fill: '#006443',
        }}
      />
      <path
        d="M1599.69 957.18c10.83-.37 13.04 9.51 16.54 16.86s10.54 15.91 11.34 21.27c.8 5.36 2.36 11.55-.28 12.29-2.65.74-23.02 3.83-28.5 3.5-5.48-.33-15.48-2.92-16.58-6.89-1.1-3.97-1.44-15.74-1.44-15.74l-4.19 1.13-7.65-5.77s-1.63-17.53-.08-24.28c1.55-6.75 6.29-17.69 7.71-17.16 1.42.53-.28 16.6 1.77 20.92s4.77 8.57 4.77 8.57 7.1-14.37 16.6-14.7Z"
        style={{
          fill: '#49465a',
        }}
      />
      <path
        d="M1475.39 510.92c-13.33 3.67-16.07 70.1-16.32 115.04-.26 47.79 20.16 123.83 21.3 148.4 1.78 38.21-6.21 177.7-6.21 177.7s3.12 6.1 19.81 7.05c19.74 1.12 35.29-2.89 35.29-2.89s12.91-144.74 11.8-204c-1.12-59.27-1.27-113.88 3.33-113.88 5.36 0 11.24 122.61 12.13 134.17 1.23 15.95 3.49 182.18 3.49 182.18s19.55 5.57 34.07 5.14c20.41-.6 22.55-5.64 22.55-5.64s-3.02-125.94-1.75-155.15c.66-15.12 21.06-143.78 19.42-174.34-2.16-40.4-8.01-69.87-8.89-77.46-5.59-48.08-4.53-95.52-4.53-95.52l-136.55 3.3-8.95 55.91Z"
        style={{
          fill: '#00a183',
        }}
      />
      <path
        d="m1496.77 349.69 48.83 27.67 61.5-26.19 2.57-9.64s-19.58-2.04-31.99-8.34c-12.02-6.1-11.74-48.98-11.74-48.98l-46.06 3.64s3.12 44.55-15.57 51.82c-19.03 7.4-7.37-1.21-7.37-1.21l-.18 11.23Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1545.23 312.72c-7.09.89-23.95-4.05-25.54-2.88-4.71 3.45-.7 16.08-6.99 18.76-6.29 2.68-34.47 5.01-47.08 11.19-10.67 5.22 3 30.6 1.86 41.33-1.14 10.74-1.72 58.32 2.85 81.94 4.57 23.63-18.14 72.72-15.66 88.83 2.69 17.46 4.9 26.07 4.99 33.7.16 13.57-1.1 21.69-1.1 21.69s57.77 23 109.14 21.52c51.37-1.48 69.17-4.61 69.17-4.61s-2.38-22.32-1.13-40.06c.73-10.35 11.92-17.13 5.21-43.95-2.99-11.97-12.64-56.24-14.02-82.05-1.55-29.05-9.82-50.34-8-60.01 3.43-18.26 24.36-36.42 15.91-45.61-12.02-13.08-50.64-21.8-55.5-25.83-4.86-4.03-5.84-15.83-7.84-17.44-2-1.61-17.71 2.4-26.28 3.47Z"
        style={{
          fill: '#497125',
        }}
      />
      <path
        d="M1535.51 314.92c4.49 3.12 15.88 2 19.04 0 7.45-4.74 19.01-17.06 21.96-21.78 3.93-6.29 8.73-36.69-1.3-44.89-16.68-13.63-10.83-31.16-22.18-30.82-6.49.19-12.45 15.84-22.02 24.14-7.16 6.2-19.92 10.44-21.52 16.22-2.38 8.6-1.85 28.61 4.88 37.83 7.96 10.89 13.7 14.14 21.14 19.31Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-c)',
        }}
      >
        <path
          d="M1537.62 244.67s-7.05-6.1-11.52-5.88c-6.24.3-11.73.91-11.73.91l.17 3.36s8.39-.1 10.68 0c3.74.15 10.78 5.45 10.78 5.45s1.99-4 1.61-3.84ZM1553.05 244.75s5.79-3.36 10.11-4.75c4.33-1.39 10.86.3 10.86.3l-.28 3.35s-7.42-.99-9.45.31c-2.33 1.49-9.76 4.7-9.76 4.7s-1.86-4.09-1.48-3.92Z"
          style={{
            fill: '#4a4630',
          }}
        />
      </g>
      <path
        d="M1556.61 293.08c.36 1.51-1.48 5.78-3.88 6.67-1.52.56-3.69 1.05-8.87 1.44-5.84.44-6.81-.3-8.1-.73s-2.85-4.37-3.28-6.39c-.28-1.3 1.34-2.95 4.83-4.29 3.41-1.31 5.27.92 7.07.48s1.58-1.28 4.67-1.3c2.94-.02 7.23 2.75 7.56 4.13Z"
        style={{
          fill: '#ee7f00',
        }}
      />
      <path
        d="m1527.66 260-4.96-.59.17-1.77 6.14.42s-1.18 1.93-1.34 1.93Z"
        style={{
          fill: '#4a4630',
        }}
      />
      <path
        style={{
          fill: '#4a4630',
        }}
        d="m1528.58 259.33-3.95-4.8 1.34-1.2 3.74 4.24-1.13 1.76z"
      />
      <path
        d="M1528.65 256.21c-1.74.84-2.4 2.6-1.51 4.27.89 1.67 2.33 1.83 3.94 1.18 1.9-.77 2.42-2.13 1.68-3.95-.52-1.28-2.32-2.37-4.11-1.51ZM1558.99 260.5l4.96-.59-.17-1.77-6.14.42s1.18 1.93 1.34 1.93Z"
        style={{
          fill: '#4a4630',
        }}
      />
      <path
        style={{
          fill: '#4a4630',
        }}
        d="m1558.47 259.52 3.8-4.62-1.29-1.15-3.6 4.07 1.09 1.7z"
      />
      <path
        d="M1557.88 256.37c1.74.84 2.4 2.6 1.51 4.27-.89 1.67-2.53 1.66-4.14 1.01-1.9-.77-2.22-1.97-1.48-3.78.52-1.28 2.32-2.37 4.11-1.51Z"
        style={{
          fill: '#4a4630',
        }}
      />
      <path
        d="M1578.19 248.49c-.47-.66-19.51 0-24.43.15-3.37.11-6.18 2.45-10.9 2.62-4.72.17-7.67-2.05-11.04-1.94-4.92.15-23.97.68-24.4 1.37-.43.69-.27 3.38.31 3.58.57.21 1.38.75 1.52 1.53.14.79 1.83 10.71 3.47 12.56 2.38 2.69 5.43 2.35 9.84 2.55 4.41.2 11.07-.24 12.65-3.82 1.16-2.64 1.62-4.08 3.4-8.59.87-2.2 2.09-3.14 4.21-3.2 2.11-.07 3.72.78 4.73 2.93 2.05 4.39 2.6 5.8 3.92 8.36 1.8 3.48 8.47 3.5 12.86 3.03 4.39-.48 7.45-.33 9.66-3.16 1.52-1.95 2.6-11.96 2.69-12.75.09-.79.86-1.38 1.42-1.63.56-.24.56-2.94.08-3.6Zm-42.9 9.57c-.56 3-.91 7.53-4.5 9.66-2.71 1.62-11.44.88-13.42.3-2.14-.62-3.49-2.32-3.89-4.32-.4-2-1-5.61-1.15-6.72-.15-1.12.03-3.37 2.01-3.75 2.9-.56 15.05-1.28 18.44-.46 1.97.48 3.06 2.33 2.51 5.29Zm38.38-2.98c-.08 1.12-.46 4.76-.74 6.78-.27 2.02-1.52 3.79-3.61 4.55-1.93.7-10.6 1.97-13.41.53-3.71-1.91-4.35-6.4-5.08-9.37-.73-2.92.25-4.84 2.18-5.44 3.33-1.03 15.5-1.07 18.43-.68 2 .26 2.31 2.5 2.24 3.62Z"
        style={{
          fill: '#a93985',
        }}
      />
      <path
        d="M1385.47 447.7c3.54 12.97 25.41 26.6 36.71 21.28s68.32-62.85 68.32-62.85l12.21-69.18s-25.64-10.19-45.58 9.09c-19.95 19.28-77.64 79.71-71.65 101.65ZM1705.64 443.36c-4.12 12.8-15.51 28.35-26.59 22.57-12.93-6.75-74.92-48.15-73.07-47.24l-21.36-86.56s36.02 1.59 55.07 21.75c19.05 20.16 72.91 67.82 65.94 89.47Z"
        style={{
          fill: '#497125',
        }}
      />
      <path
        d="M1433.84 486.15s25.58 26.86 28.61 28.35c2.09 1.03 26.29 3.8 29.37 5.27 2.12 1.02 16.22 11.72 18.5 14.02 2.12 2.14 12.41 12.15 12.41 12.15s-2.82 3.76-6.98 1.16c-4.16-2.6-9.73-8.34-10.89-9.29-1.17-.95-11.5-7.22-11.9-7.58-.56-.51-1.23.37-.79.79.77.73 10.93 7.85 11.9 8.77.97.92 16.38 13.65 16.38 13.65s-2.46 3.52-5.94 2.33c-4.39-1.49-13.02-9.48-13.84-10.28-.83-.81-11.85-8.35-12.77-9.04-.69-.52-1.17.04-.7.75.45.67 7.47 7.18 11.19 10.42 2.61 2.27 12.93 12.15 12.93 12.15s-3.52 4.22-7.27 1.1c-3.02-2.51-9.02-8.09-10.54-9.59-1.52-1.5-9.39-7.99-9.9-8.36-.78-.57-1.12-.11-.59.6.38.51 6.05 6.7 7.08 7.67s9.06 11 9.06 11-2.13 3.22-5.14 1.59c-1.68-.91-6.66-7.11-9.02-9.35-1.65-1.57-8.51-8.18-10.35-9.21-2.36-1.33-18.54-9.08-21.21-11.12-3.3-2.52-37.73-28.9-37.73-28.9l18.13-19.05Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1386.12 433.45c-5.27 11.32.13 31.91 11.85 47.81 11.72 15.89 28.04 46.77 33.66 49.64 5.62 2.87 25.01 5.7 25.01 5.7l17.49-23.01s-3.78-9.34-8.05-16.71c-4.27-7.37-26.88-49.11-31.53-67.3-3.03-11.84-27.88-22.59-27.88-22.59s-15.57 15.79-20.54 26.47Z"
        style={{
          fill: '#497125',
        }}
      />
      <path
        d="M1662.57 494.8s-25.84 26.61-28.89 28.07c-2.1 1.01-26.33 3.54-29.42 4.99-2.13 1-16.33 11.56-18.63 13.84-2.14 2.11-12.53 12.03-12.53 12.03s2.78 3.78 6.97 1.22c4.19-2.56 9.81-8.25 10.98-9.19 1.18-.94 11.57-7.11 11.97-7.47.57-.51 1.22.39.78.8-.78.72-11.01 7.75-11.98 8.65-.98.91-16.51 13.49-16.51 13.49s2.43 3.54 5.91 2.39c4.41-1.45 13.11-9.35 13.94-10.15.84-.8 11.93-8.24 12.85-8.92.69-.51 1.17.05.69.75-.45.67-7.54 7.11-11.29 10.31-2.63 2.24-13.05 12.02-13.05 12.02s3.48 4.25 7.26 1.17c3.04-2.48 9.1-8 10.63-9.48 1.53-1.48 9.47-7.9 9.98-8.27.78-.57 1.12-.1.59.61-.38.5-6.11 6.64-7.16 7.61-1.04.96-9.17 10.91-9.17 10.91s2.1 3.24 5.12 1.64c1.69-.89 6.73-7.04 9.11-9.26 1.66-1.55 8.59-8.1 10.44-9.11 2.37-1.3 18.63-8.9 21.32-10.92 3.33-2.49 38.01-28.53 38.01-28.53l-17.94-19.22Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1712.77 434.15c6.38 10.26-2.69 27.22-12.97 51.9-7.35 17.65-16.37 39.08-21.58 42.28-5.21 3.2-31.08 11.95-31.08 11.95l-16.27-18.85s.43-11.94 3.98-19.38c3.56-7.44 23.54-45.68 26.63-63.57 2.02-11.65 21.44-35.49 21.44-35.49s22.82 19.87 29.84 31.17Z"
        style={{
          fill: '#497125',
        }}
      />
    </svg>
  )
}

export default ParentsDivorcingStart
